import React from 'react'
import classNames from 'classnames'

import './community-tree-item.scss'

const CommunityTreeItem = (props) => {
  const { community, setActiveCommunity, toggleCommunityModal, memberDiscussionId, activeCommunity, isCommunityOwner } =
    props
  const { id: communityId, name: communityName, cover = [] } = community || {}
  const { cropped, original } = cover[0] || {}

  const isMemberRegistered = communityId && memberDiscussionId === communityId
  const communityCoverLink = cropped || original

  const lessonItemClasses = classNames('lesson-wrap', {
    active: communityId && activeCommunity.id === communityId,
  })

  return (
    <div className='community-tree-item'>
      {communityName && (
        <div
          className={lessonItemClasses}
          onClick={isMemberRegistered && !isCommunityOwner ? () => setActiveCommunity(community) : toggleCommunityModal}
        >
          {communityCoverLink ? (
            <img className='community-tree-item__cover' src={communityCoverLink} alt='community-cover' />
          ) : (
            <i className='far fa-image community-tree-item__cover community-tree-item__cover--no-cover' />
          )}
          <div className='lesson-name'>{communityName}</div>
        </div>
      )}
    </div>
  )
}

export default CommunityTreeItem
